import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  section: {
    backgroundColor: '#F9FBFD',
    padding: '67px 0 75px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
    },
  },
  layout: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  textColumn: {
    minWidth: 0,
    [theme.breakpoints.down('md')]: {
      marginBottom: 26,
    },
  },
  columnDivider: {
    width: 1,
    alignSelf: 'stretch',
    flexShrink: 0,
    backgroundColor: '#F5F6F7',
    margin: '0 88px',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  dividerLine: {
    height: 1,
    backgroundColor: '#F5F6F7',
  },
  dividerAfterSearch: {
    margin: '30px 0 29px',
    [theme.breakpoints.down('md')]: {
      margin: '24px 0 23px',
    },
  },
  dividerBetweenSections: {
    margin: '16px 0 15px',
  },
  dividerBeforeContinue: {
    margin: '20px 0 19px',
  },
  title: {
    color: '#040C14',
    fontSize: 40,
    fontWeight: 700,
    position: 'relative',
    lineHeight: 1.2,
    marginBottom: 55,
    '&::before': {
      position: 'absolute',
      content: "''",
      width: 40,
      height: 2,
      backgroundColor: '#000000',
      bottom: -18,
      left: 0,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 24,
      marginBottom: 37,
    },
  },
  subtitle: {
    fontSize: 14,
    lineHeight: '24px',
    color: '#040C14',
  },
  formCard: {
    width: 566,
    flexShrink: 0,
    backgroundColor: '#FFFFFF',
    padding: 32,
    borderRadius: 16,
    boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.02)',
    userSelect: 'text',
    [theme.breakpoints.down('md')]: {
      padding: '24px 16px',
      width: '100%',
    },
  },
  demoFormFields: {
    pointerEvents: 'none',
    userSelect: 'text',
    cursor: 'text',
  },
  searchField: {},
  searchInputWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
  },
  searchIcon: {
    color: '#5E6369',
    opacity: 0.87,
    position: 'absolute',
    left: 16,
    pointerEvents: 'none',
  },
  searchInput: {
    outline: 'none',
    border: '1px solid #D8DFE5',
    height: 48,
    padding: '0 16px 0 52px',
    fontSize: 14,
    lineHeight: '24px',
    width: '100%',
    boxSizing: 'border-box',
    cursor: 'text',
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    '&::placeholder': {
      color: '#A8ADB2',
      opacity: 1,
    },
  },
  fieldLabel: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: '24px',
    color: '#040C14',
  },
  ratingRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },
  ratingStars: {
    '& .MuiRating-root': {
      pointerEvents: 'none',
    },
    '& .MuiRating-iconFilled': {
      color: '#77CC21',
    },
    '& .MuiRating-iconHover': {
      color: '#77CC21',
    },
    '& .MuiRating-iconEmpty': {
      color: '#D8DFE5',
    },
  },
  reasonDelaysBlock: {},
  continueButton: {},
}));
